import { render, staticRenderFns } from "./SzButton.vue?vue&type=template&id=54fd84ca&scoped=true"
import script from "./SzButton.vue?vue&type=script&lang=js"
export * from "./SzButton.vue?vue&type=script&lang=js"
import style0 from "./SzButton.vue?vue&type=style&index=0&id=54fd84ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fd84ca",
  null
  
)

export default component.exports